<template>
  <bk-page class="demoIndexPage">
    <bk-view class="view-tab">
      <bk-view class="view-tabItem" :class="item == curTabItem ? 'select' : ''" v-for="item in iframeUrlList" @click="tabItemClick(item)">
        {{item.label}}
      </bk-view>
    </bk-view>

    <bk-view class="view-iframe">
      <transition name="fade" mode="out-in">
        <iframe v-show="curTabItem.label == 'A品牌'" src="https://mldemo.mase.cloud/MLBKGJDEMO.html?v=58"></iframe>
      </transition>
      <transition name="fade" mode="out-in">
        <iframe v-show="curTabItem.label == 'B品牌'" src="https://mldemo.mase.cloud/MLRTMDEMO.html?v=58"></iframe>
      </transition>
    </bk-view>
  </bk-page>
</template>

<script>

	export default {
		name: 'demoIndex',
		components: {

		},
		computed: {

		},
		data () {

			let iframeUrlList = [
				{url: 'https://mldemo.mase.cloud/MLBKGJDEMO.html?v=58', label: 'A品牌'},
				{url: 'https://mldemo.mase.cloud/MLRTMDEMO.html?v=58', label: 'B品牌'},
			];

			return {
				curTabItem: iframeUrlList[0],

				iframeUrlList,

				// https://mldemo.mase.cloud
				iframeUrl: 'https://mldemo.mase.cloud/MLRTMDEMO.html?v=58',
				// iframeUrl: 'https://www.o2klinik.com',
			};
		},
		async created () {


		},
		methods: {

			tabItemClick (item) {

				console.log('tabItemClick:::', item);


				this.curTabItem = item;

			}

		}
	};
</script>

<style lang="less">

.demoIndexPage {
  height: 100vh !important;
  background: #fff;

  > .view-tab {
    display: flex;
    line-height: 60px;
    top: calc(0px + env(safe-area-inset-top));
    text-align: center;
    z-index: 1000;

    > .view-tabItem {
      flex: 1;
      font-size: 18px;
      background: #fff;
      line-height: 60px;
      font-weight: bold;

      &.select {
        color: var(--color-main);
      }
    }
  }

  > .view-iframe {
    height: calc(100% - 60px - env(safe-area-inset-top));

    iframe {
      display: block;
      width: 100%;
      height: 100%;
      border: none;
      outline: none;
    }

  }

}

</style>